import { Messages2 } from 'iconsax-reactjs';
import { memo } from 'react';
import { selectUiSidebarChatOpen } from '@/store/features/ui/selectors';
import { toggleUISidebar } from '@/store/features/ui/slice';
import { SideBarContent } from '@/store/features/ui/types';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { StyledChatToggleButton } from './styled';

const ChatToggleButton = () => {
  const isChatOpen = useAppSelector(selectUiSidebarChatOpen);

  const dispatch = useAppDispatch();

  const toggle = async () => {
    dispatch(
      toggleUISidebar({
        sidebar: SideBarContent.chat,
      }),
    );
  };

  return (
    <StyledChatToggleButton $active={isChatOpen} onClick={toggle}>
      <Messages2 variant={isChatOpen ? "Bold" : "Outline"} />
    </StyledChatToggleButton>
  );
};

export default memo(ChatToggleButton);
